var path = 'public/app/partials/dashboard.html';
var html = "<div dash-class ng-if=ctrl.dashboard>\n\t<dashnav dashboard=ctrl.dashboard></dashnav>\n\n\t<div class=\"scroll-canvas scroll-canvas--dashboard\" grafana-scrollbar>\n\t\t<dashboard-settings dashboard=ctrl.dashboard ng-if=ctrl.dashboardViewState.state.editview class=dashboard-settings>\n\t\t</dashboard-settings>\n\n\t\t<div class=dashboard-container>\n\t\t\t<dashboard-submenu ng-if=ctrl.dashboard.meta.submenuEnabled dashboard=ctrl.dashboard>\n\t\t\t</dashboard-submenu>\n\n\t\t\t<dashboard-grid get-panel-container=ctrl.getPanelContainer>\n\t\t\t</dashboard-grid>\n\t\t</div>\n\t</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/partials/dashboard.html
// module id = 849
// module chunks = 2